<template>
  <b-modal id="modalError" hide-footer hide-header hide-actions>
    <div class="c-modal">
      <div class="text-end">
        <div class="text-end pe-3 pt-2">
          <span @click="$bvModal.hide('modalError')" class="c-modal__cross fs-30">
            <Icon icon="gridicons:cross-circle" />
          </span>
        </div>
      </div>
      <div class="p-4 text-center">
        <h2 class="c-modal__title">{{title}}</h2>
        <p class="mb-0">{{body}}</p>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { Icon } from '@iconify/vue2';

export default {
  props: ['title', 'body'],
  components: {
    Icon,
  },
};
</script>
